<div class="person-contact-form">
  <div class="person-contact-form__row person-contact-form__row--name">
    <app-title-name-form
      [formGroup]="formGroup().controls.nameTitle"
      [showTitle]="showTitle()"
      [disabled]="disabled()"
    />
  </div>
  <div class="person-contact-form__row person-contact-form__row--contact">
    <app-email-position-form [formGroup]="formGroup().controls.emailPosition" />
  </div>
</div>
